import { DirectUploadMedia } from "libs/directUpload";
import * as yup from "yup";

import { QuizItemStatuses } from "../../constants";

export const quizItemSchema = yup.object({
  question: yup
    .string()
    .required("Question is required")
    .min(3, "Question field cannot have less than 3 symbols."),
  mediaId: yup.string().nullable().default(null),
  media: yup.mixed<DirectUploadMedia>().nullable(),
  description: yup.string().nullable().default(null),
  status: yup
    .mixed<QuizItemStatuses>()
    .required("Status is required")
    .oneOf(
      [QuizItemStatuses.Active, QuizItemStatuses.Inactive],
      "Status must be either Active or Inactive"
    ),
  answers: yup
    .array()
    .of(
      yup.object({
        answer: yup.string().required("Option text is required"),
        isCorrect: yup.boolean().required("Correct answer is required")
      })
    )
    .required()
    .test(
      "hasCorrectAnswer",
      "At least one answer must be correct",
      (answers) => answers?.some((answer) => answer.isCorrect)
    )
});
